<template>
  <div class="account-switch">
    <rhcn-drawer @on-close="onClose">
      <div class="switch-content">
        <MerchantSwitch></MerchantSwitch>
      </div>
    </rhcn-drawer>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import RhcnDrawer from '@/components/drawer/index.vue';
import MerchantSwitch from '@/layout/base/components/iswitch/index.vue';

export default {
  components: {
    RhcnDrawer,
    MerchantSwitch,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  mounted() {
    this.initMethod();
  },
  methods: {
    async initMethod() {
    },
    onClose() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.account-switch {
  .switch-content {
    width: 450px;
    margin: 0 auto;
    margin-top: 50px;

    ::v-deep .switch-btn {
       width: 350px;
    }
  }
}
</style>
